import React from "react";

export default function Contact() {
  return (
    <div className="py-10 md:py-20">
      <div className="container px-4 mx-auto flex justify-between items-center gap-10 lg:gap-0 flex-col lg:flex-row">
        <div className="text-center lg:text-start">
          <h2 className="font-semibold text-3xl mb-2 text-neutral-900 dark:text-neutral-100">
            In need of a designer/developer?
          </h2>
          <h4 className="text-blue-600 text-2xl mb-2">
            I’m currently available for work.
          </h4>
          <a
            href="mailto:shahsalmanahmed009@gmail.com"
            className="text-white bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-3 py-2 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700"
          >
            Send Message
            <svg
              aria-hidden="true"
              className="w-5 h-5 ml-2 -mr-1"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                clipRule="evenodd"
              ></path>
            </svg>
          </a>
        </div>
        <div className="text-center lg:text-start">
          <a
            href="tel:+880 1725912669"
            className="block text-neutral-700 dark:text-neutral-400 font-semibold text-xl sm:text-2xl"
          >
            +880 1725912669
          </a>
          <a
            href="mailto:shahsalmanahmed009@gmail.com"
            className="block text-neutral-700 dark:text-neutral-400 font-semibold text-xl sm:text-2xl"
          >
            shahsalmanahmed009@gmail.com
          </a>
        </div>
      </div>
    </div>
  );
}
